import BaseColors from '@/atoms/colors/Base';
import Size from '@enums/Size';
import Typography from '@mui/material/Typography';
import LabelSize from './LabelSize';

const Label = ({ children, overrideStyles, size = Size.SMALL }) => {
  const sizeProps = LabelSize[size];

  return (
    <Typography
      variant="body2"
      sx={{
        color: BaseColors.font.tertiary,
        ...sizeProps,
        ...overrideStyles,
      }}
    >
      {children}
    </Typography>
  );
};

export default Label;
